import React, { useState } from 'react';
import Modal from './Modal';
import { Textarea } from '../Inputs';
import Button from '../Button';
import ModalConfirmation from './ModalConfirmation';
import moment from 'moment';

const CancelBilateralModal = ({
  t,
  isOpen,
  toggle,
  selectedAgreement,
  cancelOnclick,
  loading,
}) => {
  const [cancelDesc, setCancelDesc] = useState('');
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);

  const handleCancelOnClick = () => {
    cancelOnclick({
      status: 'CANCELED',
      note: cancelDesc,
    }).then(() => {
      setShowModalConfirmation(false);
    });
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <div className='km__c--modal-cancel-body'>
          <div className='km__c--modal-cancel-row'>
            <div className='km__u--text_title'>
              <div className='km__c--modal-cancel-label'>
                {t('pages.default.bilateralAgreements.table.seller')}:
              </div>
              <div className='km__c--modal-cancel-labelValue'>
                {selectedAgreement.fromOrganizationName}
              </div>
            </div>
            <div className='km__u--text_title'>
              <div className='km__c--modal-cancel-label'>
                {t('pages.default.bilateralAgreements.modal.bilateralDate')}
              </div>
              <div>
                {moment(selectedAgreement.createdDate).format(
                  'DD-MM-YYYY HH:mm:ss'
                )}
              </div>
            </div>
          </div>
          <div className='km__c--modal-cancel-row'>
            <div className='km__u--text_title'>
              <div className='km__c--modal-cancel-label'>
                {t('pages.default.bilateralAgreements.table.buyer')}:
              </div>
              <div className='km__c--modal-cancel-labelValue'>
                {selectedAgreement.toOrganizationName}
              </div>
            </div>
            <div className='km__u--text_title'>
              <div className='km__c--modal-cancel-label'>
                {t('pages.default.bilateralAgreements.table.documentCount')}:
              </div>
              <div>{selectedAgreement.amount}</div>
            </div>
          </div>
          <div className='km__c--modal-cancel-row'>
            <div className='km__u--text_title'>
              {t('pages.default.bilateralAgreements.modal.cancelDesc')}
            </div>
            <div>
              <Textarea
                minLength={10}
                value={cancelDesc}
                onChange={(e) => setCancelDesc(e.target.value)}
                id='ba-modal-description'
              />
            </div>
          </div>
          <div className='km__c--modal-cancel-buttons-container'>
            <Button
              type='secondary'
              label={t('ui.default.close')}
              onClick={toggle}
              disabled={loading}
              id='ba-modal-close'
            />
            <Button
              type='primary'
              label={t('ui.default.approve')}
              onClick={() => setShowModalConfirmation(true)}
              disabled={cancelDesc.trim().length < 10 || loading}
              id='ba-modal-cancel'
            />
          </div>
        </div>
      </Modal>
      <ModalConfirmation
        isOpen={showModalConfirmation}
        toggle={() => setShowModalConfirmation(false)}
        header={t(
          'pages.default.bilateralAgreements.bilateralCancelConfirmation.header'
        )}
        body={t(
          'pages.default.bilateralAgreements.bilateralCancelConfirmation.body'
        )}
        approve={handleCancelOnClick}
        loading={loading}
      />
    </>
  );
};

export default CancelBilateralModal;
